import { render, staticRenderFns } from "./DialogBig.vue?vue&type=template&id=7dc0a6d1&"
import script from "./DialogBig.vue?vue&type=script&lang=js&"
export * from "./DialogBig.vue?vue&type=script&lang=js&"
import style0 from "./DialogBig.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports